<button
  mat-button
  [disabled]="isDisabled"
  [ngClass]="buttonClasses"
  [matTooltip]="tooltip || ''"
  (click)="onClick()"
  [color]="color"
>
  <mat-icon *ngIf="icon && iconPosition==='start' && !loading" class="button-icon">{{ icon }}</mat-icon>

  <mat-progress-spinner
    *ngIf="loading"
    [diameter]="16"
    mode="indeterminate"
    color="accent"
    class="spinner"
  ></mat-progress-spinner>

  <ng-content *ngIf="!loading"></ng-content>

  <mat-icon *ngIf="icon && iconPosition==='end' && !loading" class="button-icon">{{ icon }}</mat-icon>
</button>
